<template>
  <b-container>
    <b-row>
      <b-col lg="6" class="my-1">
        <h5>Etiquetas del sistema</h5>

        <b-form-fieldset label="Modulos" horizontal>
          <b-form-select
            v-model="modulo"
            id="moduloSelect"
            size="sm"
            :options="options1"
            class="mb-2 form-control">
          </b-form-select>
        </b-form-fieldset>
        
        <ul>
          <li v-for="value in etiquetas" >
            {{value.nombre}}
          </li>
        </ul>

      </b-col>
    </b-row>

    <b-row v-show="modulo">
      <b-col  lg="6" class="my-1">
        <div role="group">
          <label for="new-tag">Nueva etiqueta:</label>
          <b-form-input id="new-tag" v-model="etiqueta" size="sm" placeholder="Introduzca el nombre de la nueva etiqueta"></b-form-input>
        </div>

        <b-button
             @click="agregarEtiqueta"
              variant="info"
              size="sm" 
              class="mt-2"
          >
            Agregar
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import _ from 'lodash'
  import {mapActions,mapState} from 'vuex'
  export default {
    data:function(){
      return{
        modulo:'',
        options1:[],

        etiqueta:'', //valor que va a tomar la nueva etiqueta.
      }
    },//data  
    
    computed:{
      //variable del state que tiene el id del login.
      ...mapState('login',['id']),
      ...mapState('modulos',['modulos']),
      ...mapState('etiquetas',['etiquetas'])
    },

    mounted(){
      this.init()      
    },

    watch: {
       modulo:function(val) {
        this.buscarEtiquetas(val)
       }
    },

    methods:{
      ...mapActions({
        _modulos: 'modulos/fetchModulos',
        _buscarEtiquetas: 'etiquetas/buscarEtiquetas',
        _agregarEtiqueta: 'etiquetas/agregarEtiqueta',
      }),
      init() {
        this._modulos().then(() => {
          let that = this//dentro del foreach no usar this.
            _.forEach(this.modulos, function(value,key){
              let payload = {
                  value: value.id,
                  text:  value.nombre
              }
              
              that.options1.push(payload)
            })  //_.forEach  
          
        })//then
      },//init

      buscarEtiquetas(value){
        let payload ={
          'id': value, 
        }
        this._buscarEtiquetas(payload).then(()=>{})
      },

      agregarEtiqueta(){
        let payload = {
          'id': this.modulo,
          'nombre': this.etiqueta
        }
        this._agregarEtiqueta(payload).then(()=>{
          this.buscarEtiquetas(payload.id)
          this.etiqueta = ''
        })
      },



    },

  }
</script>

<style lang="scss" scoped>
 
</style>